<template>
  <div>
    <!-- <b-button size="sm" variant="outline-success" :to="{ name: 'admin-user' }">
      Voltar
    </b-button> -->

    <b-card>
      <b-tabs>
        <b-tab title="Número Lógico">
          <b-form class="custom-form" @submit.prevent>
            <b-row>
              <!-- <b-col md="12">
                <div class="form-label-group">
                  <b-form-input
                    id="id"
                    placeholder="ID"
                    v-model="form._id"
                    disabled
                  />
                  <label for="id">ID</label>
                </div>
              </b-col> -->

              <b-col md="4">
                <div class="form-label-group">
                  <b-form-input
                    id="siga_nl_update"
                    placeholder="Nome"
                    v-model="form.siga_nl_update"
                  />
                  <label for="siga_nl_update">NL Atualização</label>
                </div>
              </b-col>
              
              <b-col class="mb-2" md="12"><hr /></b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="dt-created"
                    placeholder="Data Criação"
                    v-model="form.dt_create"
                    disabled
                  />
                  <label for="dt-created">Data Criação</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="email-created"
                    placeholder="Email Criação"
                    v-model="form.email_create"
                    disabled
                  />
                  <label for="email-created">Email Criação</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="dt-update"
                    placeholder="Data Alteração"
                    v-model="form.dt_update"
                    disabled
                  />
                  <label for="dt-update">Data Alteração</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="email-update"
                    placeholder="Email Alteração"
                    v-model="form.email_update"
                    disabled
                  />
                  <label for="email-update">Email Alteração</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="dt-delete"
                    placeholder="Data Desativação"
                    v-model="form.dt_delete"
                    disabled
                  />
                  <label for="dt-delete">Data Desativação</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="email-delete"
                    placeholder="Email Desativação"
                    v-model="form.email_delete"
                    disabled
                  />
                  <label for="email-delete">Email Desativação</label>
                </div>
              </b-col>

              <b-col cols="12">
                <b-form-group>
                  <b-form-checkbox
                    id="active"
                    name="active"
                    v-model="form.active"
                  >
                    Ativo
                  </b-form-checkbox>
                </b-form-group>
              </b-col>

              <b-col>
                <b-button
                  type="submit"
                  variant="primary"
                  class="mr-1"
                  @click="onSubmit"
                >
                  Enviar
                </b-button>
                <b-button variant="danger" class="mr-1" @click="onBackPage">
                  Voltar
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BForm,
  BButton,
  BTabs,
  BTab,
  BCard,
} from "bootstrap-vue";
import logicalNumberService from "@/providers/logicalNumberService";
import messagesNotifyHelper from "@/helpers/messages-notify-helper";
import convertDatetimeHelper from "@/helpers/convert-datetime-helper";
import AppConstants from '@/appConstants';

export default {
  props: {},
  data() {
    return {
      dataID: null,
      form: {
        _id: "",
        name: "",
        siga_nl_update: "",
        dt_create: "",
        dt_update: "",
        dt_delete: "",
        email_create: "",
        email_update: "",
        email_delete: "",
        email_template_path: "",
      },
    };
  },
  created() {
    this.$store.dispatch("admin/updatePageTitle", 'Novo Numero Lógico');
    if (this.isUpdate) {
      this.dataID = this.$route.params.id;
      console.log("dataid: ", this.dataID);
      this.getLogicalNumberDetail();
    }
  },
  computed: {
    isUpdate() {
      if (this.$route.params.id) {
        return true;
      }
      return false;
    },
  },
  watch: {
    "form.name"(val) {
      if (val) {
        this.$store.dispatch("admin/updatePageTitle", val);
      } else {
        this.$store.dispatch("admin/updatePageTitle", 'Novo Numero Lógico');
      }
    }
  },
  methods: {
    onBackPage() {
      this.$router.push(AppConstants.NAVIGATION_PAGE_ADM_LOGICAL_USER);
    },
    onSubmit() {
      const sendform = JSON.parse(JSON.stringify(this.form));
      if (sendform.channel.length > 0) {
        sendform.channel = sendform.channel.map(item => item.id || '');
      }
      logicalNumberService
        .registerLogicalNumber(sendform, new URLSearchParams())
        .then((res) => {
          console.log(res);
          if (this.isUpdate) {
            messagesNotifyHelper.updatedRecordNotify();
          } else {
            messagesNotifyHelper.createdRecordNotify();
            this.onBackPage();
          }
        })
        .catch((err) => console.log(err));
    },
    getLogicalNumberDetail() {
      const params = new URLSearchParams();
      logicalNumberService
        .getLogicalNumberDetails(this.dataID, params)
        .then((res) => {
          // console.log(res);
          this.form._id = res._id;
          this.form.name = res.name;
          this.form.siga_nl_update = res.siga_nl_update;
          this.form.dt_create = convertDatetimeHelper.convertStringToDateTime(
            res.dt_create
          );
          this.form.dt_update = res.dt_update
            ? convertDatetimeHelper.convertStringToDateTime(res.dt_update)
            : res.dt_update;
          this.form.dt_delete = res.dt_delete
            ? convertDatetimeHelper.convertStringToDateTime(res.dt_delete)
            : res.dt_delete;
          this.form.email_create = res.email_create;
          this.form.email_update = res.email_update;
          this.form.email_delete = res.email_delete;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  components: {
    BButton,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BTabs,
    BTab,
    BCard,
  },
};
</script>

<style lang="scss">
</style>